__turbopack_context__.v({
  "eyebrow": "WebsiteDevelopmentServicesCardSection-module__yOuWcG__eyebrow",
  "heading": "WebsiteDevelopmentServicesCardSection-module__yOuWcG__heading",
  "section": "WebsiteDevelopmentServicesCardSection-module__yOuWcG__section",
  "title": "WebsiteDevelopmentServicesCardSection-module__yOuWcG__title",
});
